/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreBank131PayWithRecurrentResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreBank131PayWithRecurrentResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreBank131PayWithRecurrentResponseFromJSON(json) {
    return FxIdWebFeaturesStoreBank131PayWithRecurrentResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PayWithRecurrentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
    };
}
export function FxIdWebFeaturesStoreBank131PayWithRecurrentResponseToJSON(json) {
    return FxIdWebFeaturesStoreBank131PayWithRecurrentResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PayWithRecurrentResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreBank131PayWithRecurrentResponse.js.map